import type { Menu, ParentCategory, CollectionUUID, CollectionSlug } from '@library/menu-service'

import { actionTypes } from 'actions/actionTypes'

type MenuV3ParentCategoriesSlice = {
  parentCategories: ParentCategory[]
}
export type MenuParentCategoriesState = {
  menuV3ParentCategories?: MenuV3ParentCategoriesSlice
}

type Action = {
  type: typeof actionTypes.MENU_SERVICE_V3_DATA_RECEIVED
  response: Menu
}

const initialState: MenuV3ParentCategoriesSlice = {
  parentCategories: [],
}

export const menuParentCategoriesReducers = {
  menuV3ParentCategories: (state = initialState, action: Action): MenuV3ParentCategoriesSlice => {
    switch (action.type) {
      case actionTypes.MENU_SERVICE_V3_DATA_RECEIVED: {
        const categoryTitles = action.response.categories

        const parentCategories = (action.response.parent_categories ?? []).map(
          (parent): ParentCategory => ({
            id: parent.id as CollectionUUID,
            slug: parent.slug as CollectionSlug,
            isLinkable: parent.is_linkable,
            name: parent.name ? parent.name : undefined,
            description: parent.description ? parent.description : undefined,
            type: parent.type,
            categories: parent.categories
              .map((child) => {
                const shortTitle = categoryTitles[child.id]?.short_title
                if (!shortTitle) {
                  // skip child categories that are not available in the global list
                  return null
                }

                return {
                  id: child.id as CollectionUUID,
                  shortTitle,
                  image: child.image,
                }
              })
              .filter((item) => item !== null) as ParentCategory['categories'],
          }),
        )

        return {
          parentCategories,
        }
      }
      default: {
        return state
      }
    }
  },
}
